module.exports = [
  "// A sample tag file with some errors",
  "// To change the source, click 'Source' button above.",
  "",
  "var riot = require('riot')",
  "",
  "<valid-tag>",
  "  <h1>{ title }</h1>",
  "  <p>{ message }</p>",
  "<invalid-flagment",
  "  this.title = 'Hello world!'",
  "  this.message = 'I am hungry...'",
  "</valid-tag>",
  "",
  "<invalid-t",
  "  <h1>{ title }</h1>",
  "  <p>{ message }</p>",
  "",
  "  this.title = 'Hello world!'",
  "  this.message = 'I am hungry...'",
  "</invalid-t",
  "",
  "console.log('end of file')"
].join('\n')
